import { LandingLayout } from 'layouts';
import { useLocation, useParams } from 'react-router';
import { ContentLeft, Footer, Header, type HeaderItem, NewPassword } from 'features/onboarding';
import { useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type NewPasswordLocationState = { email?: string } & OnboardingLocationState;

type RouteParams = {
  token: string;
};

const PageNewPassword = () => {
  const { token } = useParams<RouteParams>();
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: NewPasswordLocationState | undefined = location.state;
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin, onNavigateToSignUp, onReplaceToLogin } =
    useOnboardingNavigation<NewPasswordLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <NewPassword
          email={state?.email}
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onSuccessChangePassword={onReplaceToLogin}
          token={token}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PageNewPassword;
